import UAParser from 'ua-parser-js'

const parser = new UAParser()
const os = parser.getOS()

export const sendMetric = async ({ event, gtm, amplitude }) => {
  const date = new Date()
    .toISOString()
    .replace('T', ' ')
    .slice(0, 19)
  window.dataLayer = window.dataLayer || []

  if (gtm) {
    await window.dataLayer.push({
      event,
      ...gtm
    })
  }

  if (amplitude) {
    await window.amplitude.getInstance().logEvent( event, {
      ...amplitude,
      PARAM_DATE_TIME: date,
      OS_NAME: os.name,
      OS_VERSION: os.version,
    })
  }
}
